import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Product } from '../product';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from '../product.service';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { CartService } from '../../core/cart.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { dinero, toUnit } from 'dinero.js';
import { CanonicalService } from '../../core/canonical.service';
import { CAD } from '@dinero.js/currencies';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailsComponent implements OnInit {
  product$: Observable<Product> | undefined;
  counter = 1;
  pageNumber = 1;
  productImages: string[] = ['assets/images/no-product.svg'];

  constructor(
    private readonly productService: ProductService,
    private readonly cartService: CartService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private meta: Meta,
    private title: Title,
    protected readonly googleAnalytics: GoogleAnalyticsService,
    private readonly canonicalService: CanonicalService
  ) {}

  ngOnInit(): void {
    this.product$ = this.route.params.pipe(
      switchMap((params) => this.productService.getOneByIdPublic(params['id'])),
      tap(
        (product) =>
          (this.productImages =
            this.productService.getProductImagesUrlsCached(product))
      ),
      tap((product) => this.setMeta(product)),
      tap((product) => this.emitViewItemEvent(product))
    );
  }

  addToCart(product: Product, quantity: number): boolean {
    if (quantity === 0) return false;
    this.cartService.addToCart(product, quantity);
    return true;
  }

  setMeta(product: Product): void {
    const metaTags: MetaDefinition[] = [
      {
        name: 'description',
        content: product.description || `Produit ${product.name}`,
      },
      { property: 'og:title', content: product.name },
      {
        property: 'og:url',
        content: environment.baseURL + this.router.routerState.snapshot.url,
      },
      {
        property: 'og:description',
        content: product.description || `Produit ${product.name}`,
      },
      {
        property: 'og:image',
        content: this.productImages[0],
      },
    ];
    metaTags.forEach((m) => this.meta.updateTag(m));
    this.title.setTitle(product.name);
    this.canonicalService.setCanonicalURL();
  }

  private emitViewItemEvent(product: Product) {
    const currencyCode = this.cartService.currencyCode;
    this.googleAnalytics.gtag('event', 'view_item', {
      currency: currencyCode,
      items: [
        {
          item_name: product.name,
          price: toUnit(
            dinero({
              amount: product.price,
              currency: CAD,
            })
          ),
          currency: currencyCode,
          quantity: 1,
        },
      ],
      value: toUnit(
        dinero({
          amount: product.price,
          currency: CAD,
        })
      ),
    });
  }
}
